/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Pos_Lot_Debt_ShortfallInputs */

const vi_pos_lot_debt_shortfall = /** @type {(inputs: Pos_Lot_Debt_ShortfallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thiếu ${i?.qty} ${i?.unit} — bán nợ lô`)
};

/**

* @param {Pos_Lot_Debt_ShortfallInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_debt_shortfall = /** @type {((inputs: Pos_Lot_Debt_ShortfallInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Debt_ShortfallInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_debt_shortfall(inputs)
});